export interface Base64File {
	fileName: string;
	fileData: string;
	fileContentType: string;
}

export async function filesToBase64(files: File[]): Promise<Base64File[]> {
	return Promise.all(
		files.map(
			(file) =>
				new Promise<Base64File>((resolve) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						if (typeof reader.result === "string") {
							resolve({
								fileName: file.name,
								fileData: reader.result,
								fileContentType: file.type || "image/png",
							});
						}
					};
				})
		)
	);
}
